import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/containers/Events/AwsLaEvent/index.tsx");
